/**
 * ParticipationsService
 * @module Services/domain/ParticipationsService
 * @description Offers a set of methods to help performing participations related actions
 */

import HttpService from "../http/HttpService";
import LinksProvider from "../http/LinksProvider";

const self = {};

/**
 * Creates a participation
 * @author Sameh Bellez
 * @alias create
 * @param reference {string} The pot reference
 * @param request {object} the request payload
 * @memberof module:Services/domain/ParticipationsService
 * @returns {promise}  A promise containing the created payment
 */
self.create = (reference, request) => {
  return HttpService().post(LinksProvider.get(LinksProvider.API.PARTICIPATIONS.PARTICIPATIONS, {reference: reference}), request)
    .then(result => result.payment);
};

/**
 * Gets a participation
 * @author Seif Khiari
 * @alias get
 * @param reference {string} The pot reference to which the participation belongs
 * @param orderId {string} The participation orderId
 * @memberof module:Services/domain/ParticipationsService
 * @returns {promise}  A promise containing the resulting participation
 */
self.get = (reference, orderId, ctx) => {
  return HttpService(ctx).get(LinksProvider.get(LinksProvider.API.PARTICIPATIONS.PARTICIPATION, {
    id: reference,
    orderId: orderId
  }))
    .then(result => result.participation);
};

/**
 * updates a participation
 * @author Seif Khiari
 * @alias update
 * @param potId {string} The pot reference to which the participation belongs
 * @param orderId {string} The participation orderId
 * @param values {string} object containing values to update
 * @memberof module:Services/domain/ParticipationsService
 * @returns {promise}  A promise containing the updated participation
 */
self.update = (potId, orderId, values) => {
  return HttpService().put(LinksProvider.get(LinksProvider.API.PARTICIPATIONS.UPDATE, {
    id: potId,
    orderId: orderId
  }), values)
    .then(result => result.participation);
};

/**
 * Gets participants list for a pot
 * @author Sameh Bellez
 * @alias getParticipants
 * @param reference {string} The pot reference
 * @memberof module:Services/domain/ParticipationsService
 * @returns {promise}  A promise containing the participants list
 */
self.getParticipants = (reference) => {
  return HttpService().get(LinksProvider.get(LinksProvider.API.POTS.PARTICIPANTS, {reference: reference}))
    .then(data => data.participants);
};

export default self;
